import { Platform } from '@ionic/angular';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-products-skeleton',
  templateUrl: './products-skeleton.component.html',
  styleUrls: ['./products-skeleton.component.scss'],
})
export class ProductsSkeletonComponent implements OnInit {
  // how many placeholder cards to show, and how many per row on desktop
  @Input() count: number = 4;
  @Input() columns: number = 4;

  constructor(public platform: Platform) {}

  ngOnInit() {}

  get items(): number[] {
    return Array.from({ length: this.count }, (_, i) => i);
  }

  get gridColumns(): string {
    if (this.platform.is('mobile')) return 'repeat(2, minmax(0, 1fr))';
    // never squeeze cards below 210px on smaller desktop screens
    return `repeat(auto-fill, minmax(max(210px, calc(100% / ${this.columns} - 1px)), 1fr))`;
  }
}
